import lessColor from '@/styles/index.less'
export const levelColors = [
  { level: '正常', color: lessColor['normal'], index: 1 },
  { level: '轻微', color: lessColor['slight'], index: 2 },
  { level: '一般', color: lessColor['ordinary'], index: 3 },
  { level: '严重', color: lessColor['severity'], index: 4 },
  { level: '致命', color: lessColor['deadly'], index: 5 },
]
export default {
  ...lessColor,
}
